(function() {
    'use strict';
    angular
        .module('MW.ContactManager.TemplateList', [
            'ngMaterial',
            'pascalprecht.translate',
            'MW.Influencers.EmailTemplateService',
            'MW.Influencers.IcmDialogService',
            'MW.ContactManager.CustomToastService',
            'MW.ContactManager.CustomBannerService',
            'MW.Influencers.TextFilters'
        ])
        .component('templateList', {
            templateUrl: 'icm-web/views/partials/template_list_component',
            bindings: {
                editTemplateFn: '&',
                createOutreachFn: '&',
                duplicateTemplateFn: '&',
                createTemplateFn: '&'
            },
            controller: TemplateListComponentController
        })
        .controller('TemplateListComponentController', [
            '$scope',
            '$translate',
            '$mdDialog',
            '$mdToast',
            'EmailTemplateService',
            'DialogService',
            'mwCustomToastService',
            'mwCustomBannerService',
            TemplateListComponentController
        ]);

    function TemplateListComponentController($scope, $translate, $mdDialog, $mdToast, EmailTemplateService, DialogService, mwCustomToastService, mwCustomBannerService) {
        this.$scope = $scope;
        this.EmailTemplateService = EmailTemplateService;
        this.DialogService = DialogService;
        this.$mdDialog = $mdDialog;
        this.$translate = $translate;
        this.$mdToast = $mdToast;
        this.mwCustomToastService = mwCustomToastService;
        this.mwCustomBannerService = mwCustomBannerService;
        this.selectedItems = [];
        this.items = [];
        this.findTemplateText = this.findTemplateText || '';
        this.isSearchActive = !!this.findTemplateText;
        this.paging = {
            itemsPerPage: 50,
            selectedPage: this.pageNumber || 1,
            totalItems: 0
        };

        this.deleteSuccessToastMessage = this.$translate.instant('icm-outreach__template--delete-success-toast');
        this.confirmDeleteTitle = this.$translate.instant('icm-outreach__template--confirm-delete-header');
        this.confirmDeleteBody = this.$translate.instant('icm-outreach__template--confirm-delete-description');
        this.deleteAlertBannerText = this.$translate.instant('icm-outreach__template--delete-alert-banner-text');

        this.bulkDeleteConfirmTitle = this.$translate.instant('icm-outreach__template--bulk-delete-confirm-title');
        this.bulkDeleteConfirmBody = this.$translate.instant('icm-outreach__template--bulk-delete-confirm-body');
        this.bulkDeleteSuccessMessage = this.$translate.instant('icm-outreach__template--bulk-delete-success-message');
        this.bulkDeleteAlertBannerText = this.$translate.instant('icm-outreach__template--bulk-delete-alert-banner-text');

        this.$onInit = function () {
            //init the templates
            this.EmailTemplateService.getAllTemplatesByCompany().then(()=> {
                this.items = this.EmailTemplateService.getTemplates();
            });
            this.orderBy = 'title';
            this.changeOrderBy = function changeOrderBy(column) {
                if(this.isAscending()) {
                    this.orderBy = column;
                } else {
                    this.orderBy = `-${column}`;
                }
            };
            this.isOrderedBy = function isOrderedBy(column) {
                let regex = new RegExp(`^(?:-?)(?:${column})$`);
                let regexMatch = this.orderBy.match(regex);

                return (regexMatch === null ? false : true);
            };
            this.sortAscending = function sortAscending() {
                if(this.orderBy.match(/^-/)) {
                    this.orderBy = this.orderBy.replace(/^-/, '');
                }
            };
            this.sortDescending = function sortDescending() {
                if(!this.orderBy.match(/^-/)) {
                    this.orderBy = `-${this.orderBy}`;
                }
            };
            this.isAscending = function isAscending() {
                return (this.orderBy.match(/^-/) === null ? true : false);
            };

            this.onSearchToggle = function(isSearchActive) {
                this.isSearchActive = isSearchActive;
            };

            this.edit = function edit(event, itemId) {
                this.editTemplateFn({ev: event, id: itemId});
            };

            this.createEmailWithTemplate = function createEmailWithTemplate(itemId) {
                this.createOutreachFn({id: itemId});
            };

            this.duplicateTemplate = function duplicateTemplate(event, itemId) {
                this.duplicateTemplateFn({ev: event, id: itemId});
            };

            this.search = function search(findTemplateText) {
                this.items = this.EmailTemplateService.getTemplates();
                this.findTemplateText = findTemplateText;

                if (findTemplateText.length > 0) {
                    this.templatesList = this.items.filter((template) => {
                        if (template.title.toLowerCase().indexOf(findTemplateText.toLowerCase()) > -1) {
                            return template;
                        }
                    });

                    this.items = this.templatesList;
                }
            };

            this.deleteTemplate = function(event, id) {
                this.$mdDialog.show(
                    this.$mdDialog.mwConfirm()
                        .class('icm-confirmation-modal')
                        .title(this.confirmDeleteTitle)
                        .textContent(this.confirmDeleteBody)
                        .ok(this.$translate.instant('Ok'))
                        .cancel(this.$translate.instant('Cancel'))
                        .targetEvent(event)
                ).then(
                    () => {
                        this.$mdDialog.hide();
                        this._performDelete(event, id);
                    },
                    () => {
                        this.$mdDialog.cancel();
                    }
                );
            };

            this._performDelete = function(event, templateId) {
                this.EmailTemplateService.deleteTemplateById(templateId)
                    .then(() =>{
                        this.refreshTemplates();

                        this.$mdToast.show(
                            this.mwCustomToastService.simpleTimedClosable(this.deleteSuccessToastMessage)
                        );
                    })
                    .catch(() => {
                        this.openAlertBanner(this.deleteAlertBannerText, this._performDelete, [event, templateId]);
                    });
            };

            this._performBulkDelete = function _performBulkDelete(event, templateIds) {
                this.EmailTemplateService.deleteTemplateByIds(templateIds)
                    .then(() => {
                        this.resetSelectedItems();
                        this.refreshTemplates();

                        this.$mdToast.show(
                            this.mwCustomToastService.simpleTimedClosable(this.bulkDeleteSuccessMessage)
                        );
                    })
                    .catch(() => {
                        this.openAlertBanner(this.bulkDeleteAlertBannerText, this._performBulkDelete, [event, templateIds]);
                    });
            };

            this.bulkDelete = function bulkDelete(event, templateIds) {
                this.$mdDialog.show(
                    this.$mdDialog.mwConfirm()
                        .class('icm-confirmation-modal')
                        .title(this.bulkDeleteConfirmTitle)
                        .textContent(this.bulkDeleteConfirmBody)
                        .ok(this.$translate.instant('Ok'))
                        .cancel(this.$translate.instant('Cancel'))
                        .targetEvent(event)
                ).then(
                    () => {
                        this.$mdDialog.hide();
                        this._performBulkDelete(event, templateIds);
                    },
                    () => {
                        this.$mdDialog.cancel();
                    }
                );
            };

            this.openAlertBanner = function openAlertBanner(alertBannerText, retryCallback, callbackArgs) {
                const outreachTemplateListController = this;
                this.mwCustomBannerService.alertWithRetry(alertBannerText, retryCallback, callbackArgs, outreachTemplateListController,'.banner-space');
            };

            this.refreshTemplates = function () {
                this.EmailTemplateService.getAllTemplatesByCompany().then(() => {
                    this.search(this.findTemplateText);
                });
            };

            this.isEmptyStateVisible = function() {
                let isVisible = false;
                if (this.findTemplateText.length > 0 && this.items.length === 0) {
                    isVisible = true;
                }
                else {
                    isVisible = (!this.EmailTemplateService.getIsLoadingTemplates() && this.EmailTemplateService.getTemplates().length === 0);
                }
                return isVisible;
            };

            this.resetSelectedItems = function() {
                this.selectedItems = [];
            };

            this.$scope.$on('refreshTemplatesSelected', () =>{
                this.resetSelectedItems();
            });

            this.$scope.$on('updateTemplates', () =>{
                this.EmailTemplateService.getAllTemplatesByCompany().then(()=>{
                    this.search(this.findTemplateText);
                });
            });

            this.createTemplate = function createTemplate(event) {
                this.createTemplateFn({ev: event});
            };
        };
    }
}());
